import TopHeader from "./TopHeader";
import SubHeader from "./SubHeader";
import StatGptNavbar from "./StatGptNavbar";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ParentHeader = () => {
  const { pathname } = useLocation();
  const isMyLeaguesInner = /^\/my-leagues\/[^/]+/.test(pathname);
  const hideTopHeader =
    pathname === "/leagues-home" ||
    isMyLeaguesInner ||
    pathname.startsWith("/tournamentDetails/") ||
    pathname.startsWith("/tournaments/tournaments-details") ||
    pathname.startsWith("/tournaments/team-info") ||
    pathname.startsWith("/tournaments/create-tournament") ||
    pathname.startsWith("/tournaments/create-division") ||
    pathname.startsWith("/tournaments/schedule-match") ||
    pathname.startsWith("/ground-details/");

  useEffect(() => {
    document.body.classList.toggle("route-hide-top-header", hideTopHeader);

    return () => {
      document.body.classList.remove("route-hide-top-header");
    };
  }, [hideTopHeader]);

  const hideSubHeader =
    pathname === "/" ||
    pathname === "/home" ||
    pathname.startsWith("/my-team") ||
    (pathname.startsWith("/my-leagues") && !isMyLeaguesInner) ||
    pathname.startsWith("/create-league") ||
    pathname.startsWith("/features/league-manager") ||
    pathname.startsWith("/features/live-streaming") ||
    pathname.startsWith("/coming-soon") ||
    pathname.startsWith("/tournaments/player-profile") ||
    pathname.startsWith("/matches-details") ||
    pathname.startsWith("/stat-gpt") ||
    pathname.startsWith("/pricing") ||
    pathname.startsWith("/about") ||
    pathname.startsWith("/careers") ||
    pathname.startsWith("/features/ai-highlights") ||
    pathname.startsWith("/features/scoring") ||
    pathname.startsWith("/profile") || 
    pathname.startsWith("/streamer-dashboard");

  const showStatGptNavbar = pathname.startsWith("/stat-gpt");

  return (
    <>
      {!hideTopHeader && <TopHeader />}
      {!hideSubHeader && <SubHeader />}
      {showStatGptNavbar && <StatGptNavbar />}
    </>
  );
};
export default ParentHeader;
